<template>
    <div id="Statistics">

        <Head />
        <div class="hotspot clear">
            <Nav ms="/Bgreviewone" />
            <div v-if="tabClick == 0" class="H-right">
                <div class="title1">成果审核管理</div>
                <div class="H-header">
                    <div class="t-left">
                        <el-date-picker v-model="year" type="year" @change="setYear" :default-value="value"
                            value-format="yyyy" :picker-options="pickerOptions" placeholder="请选择" :clearable="false">
                        </el-date-picker>
                        <el-select v-model="restatus" @change="getCg">
                            <el-option value="1" label="待审核">待审核</el-option>
                            <el-option value="2" label="已审核">已审核</el-option>
                            <el-option value="3" label="子级公司未审核">子级公司未审核</el-option>
                        </el-select>
                        <el-input placeholder="请输入成果名称" v-model="keyword" clearable></el-input>
                        <el-checkbox v-show="restatus == 1" :indeterminate="isIndeterminate" v-model="checkAll"
                            @change="handleCheckAllChange">全选</el-checkbox>
                        <div v-show="restatus == 1" class="btn btnmini" @click="openEl"
                            style="width: 1rem;margin-left:.2rem">
                            批量操作
                        </div>
                    </div>
                </div>
                <div class="t_main">
                    <div class="table" v-if="tableData && tableData.length > 0" :class="restatus == 1 ? '' : 'show'">
                        <!-- <div class="list" v-for="(item,index) in tableData" :key="index"> -->
                        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                            <el-checkbox v-for="item in tableData" :key="item" :label="item" class="list">
                                <div class="btn btnmini" id="pxbut" v-if="item.lx == 1" @click="tabchange(1, item)">
                                    审核
                                </div>
                                <div class="btn btnmini" id="px" v-show="restatus == 2 || restatus == 3"
                                    @click="tabchange(1, item)">
                                    查看
                                </div>
                                <div class="btn btnmini" style="margin-top:.5rem;background:#67C23A"
                                    @click="getJd(item.ID)">
                                    查看进度
                                </div>
                                <div class="btn btnmini" style="margin-top:1rem;background:#e83131"
                                    @click="downloadAll(item.ID)">
                                    一键下载
                                </div>
                                <div class="l-title">
                                    <span>申请报告名称：</span>
                                    <span>{{ item.Title }}</span>
                                </div>
                                <div class="l-info-box">

                                    <div class="l-info">
                                        <div class="l-info-time">
                                            <span style="color:#000;">申报单位: {{ item.CompanyName }}</span>
                                            <p style="color:	#C0C0C0;margin-top:.05rem">申报时间: {{ item.DeclarTime }}</p>
                                        </div>
                                        <div class="l-info-text">
                                            <span>{{ item.ParentClassName }}</span>
                                            <span>{{ item.ClassName }}</span>
                                            <!-- <span>分类: {{item.Classname}}</span>
                        <div>省会: {{item.Proname}}</div>-->
                                        </div>

                                    </div>
                                    <div class="l-info" style="display:flex">

                                        <div class="l-info-name" v-if="restatus != 3">
                                            <div v-if="item.lx == 1 && item.Status != 3">待审核</div>
                                            <div v-else-if="item.Status == 3">审核拒绝</div>
                                            <div v-else-if="item.lx == 2">本公司完成审核</div>
                                            <div v-else>完成审核</div>
                                            <div class="hint" style="color:red" v-show="item.Status == 3">
                                                *请务必退回至申请人作出修改后,才能再次提交
                                            </div>
                                        </div>
                                        <div class="l-info-name">当前审核节点：
                                        </div>
                                        <div class="l-info-loop">
                                            <span> {{ item.CheckName }}</span>
                                        </div>
                                    </div>
                                </div>

                            </el-checkbox>
                        </el-checkbox-group>
                        <!-- </div> -->
                        <el-pagination style="text-align: right;height: 0.45rem;" v-if="tableData.length > 0"
                            @current-change="CurrentChange1" @size-change="handleSizeChange1" :current-page="Page1"
                            :page-size="PageSize1" :page-sizes="[10, 20, 30]"
                            layout="total,sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                    </div>
                    <div class="empty-content" v-else>
                        暂无数据
                    </div>
                </div>
            </div>
            <div v-if="tabClick == 1" class="H-right">
                <div class="btn btnmini" style="margin-bottom: 0.2rem;" @click="tabchange(0)">返回</div>
                <div class="titleP">
                    <img src="../../assets/back/t.png" alt />
                    <b>评审内容</b>
                </div>
                <div class="info">
                    <div>
                        成果名称：
                        <b>{{ user.Title }}</b>
                    </div>
                    <div>
                        申报单位：
                        <b>{{ user.CompanyName }}</b>
                    </div>
                    <div class="left-button">
                        成果报告申请表:
                        <!-- <span class="span1" @click="tabchange(2,0,1)">预览</span> -->
                        <div class="lastBtn">
                            <el-button type="primary" style="width:1rem" @click="tabchange(2, 0, 1)">预览</el-button>
                            <el-button style="width:1rem;background: rgb(243, 37, 47);color:#fff"
                                @click="dowCg(1)">下载</el-button>
                        </div>
                    </div>
                    <div class="left-button">
                        成果主报告:
                        <!-- <span class="span2" @click="tabchange(2,0,2)">预览</span> -->
                        <div class="sendBtn">
                            <el-button type="primary" style="width:1rem" @click="tabchange(2, 0, 2)">预览</el-button>
                            <el-button style="width:1rem;background: rgb(243, 37, 47);color:#fff"
                                @click="dowCg(2)">下载</el-button>
                        </div>
                    </div>
                    <div>
                        成果附件:
                        <el-button
                            style="width:1rem;background: rgb(243, 37, 47);color:#fff;margin-left:2.16rem;height:.45rem"
                            @click="tabchange(2, 0, 3)">下载</el-button>
                        <!-- <span>无</span> -->
                    </div>
                    <!-- <div>上传时间：<span>2019-02-25</span></div>
          <div><span>成果摘要：</span><div>由于现代网络技术的不断发展，我国长期的能源产业——煤炭经济运营模式也开始发生变化。我国的煤炭企业面临着，经济运营模式转型的巨大挑战，要想实现可持续发展，就必须将煤炭企业的运营方案与现代网络技术相互结合。在信息化背景下，煤炭企业要在企业内部信息化建设上进行调整，做到与时俱进，不断创新。煤炭工程成本管理提高企业经济效益</div></div>-->
                    <!-- <div class="clear">
            <span></span>
            <div style="font-weight:bold;">{{user.Title}}</div>
          </div>
          <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,1)">
              成果申请表
            </div>
          </div>
          <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,2)">
              成果主报告
            </div>
          </div>
           <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,3)">
              成果附件
            </div>
          </div>-->
                </div>
                <div class="jieguo">
                    <i></i>
                    <span class="jieguospan">查重结果:</span>
                    <span class="repetition" v-if="baogao.wordRepetitionRate">{{ percentage }}%相似</span>
                    <!-- <a :href="baogaoUrl||'javascript:;'" target="_blank" style="color:#2D65D2;">点击查看</a> -->
                    <a @click="tabchange(2, 0, 4)" style="color:#2D65D2;">点击查看</a>
                </div>
                <div class="yijian" v-show="restatus == 1">
                    <div>
                        <div></div>
                        <span>审核意见：</span>
                    </div>
                    <textarea name id cols="30" rows="10" v-model="comment"></textarea>
                </div>
                <div class="sub" v-show="restatus == 1">
                    <div class="btn" @click="submit(2)">通过</div>
                    <div class="btn" style="margin-left: 0.5rem;background:#D93838;" @click="submit(3)">不通过</div>
                </div>
            </div>
            <div v-show="tabClick == 2" class="H-right">
                <div class="btn btnmini" style="margin-bottom: 0.2rem;position:fixed;z-index:30" @click="tabchange(1)">
                    返回
                </div>
                <Preview v-if="lookStatus == 1" :yulan="yulan" :CompanyID="CompanyID" :sbbYear="sbbYear" />
                <FullPreview v-if="lookStatus == 2" :zbg="user.ID" />
                <iframe v-if="lookStatus == 4" widht="1000" height="1000" style="width:100%" name="hrong" frameborder="0"
                    :src="baogao.Result"></iframe>
                <!-- <iframe id='bbb' v-show="lookStatus==2" width=1000 name=hrong height=1000 frameborder="0"></iframe>
        <iframe id='aaa' v-show="lookStatus==3" width=1000 name=hrong height=1000 frameborder="0"></iframe>-->
            </div>
        </div>
        <el-dialog v-if="jindu.length > 0" title="成果进度" :visible.sync="dialogVisible" :destroy-on-close="true" center
            top="20vh" width="70%" style="font-size:.2rem">
            <el-steps v-if="jindu.length > 0" :active="active" direction="vertical" align-center>
                <el-step :title="item.zt" v-for="(item, i) in jindu" :key="i">
                    <template slot="description">
                        <div class="content">
                            <div>
                                <span>{{ item.datetime }}</span>
                                <div>{{ item.companyName }}</div>
                                <div v-if="item.comment" class="contentMsg">
                                    <p style="font-weight: 700;height:.3rem">审核意见：</p>
                                    <div class="opinion">{{ item.comment }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-step>
                <el-step :title="end.zt" v-if="end.time">
                    <template slot="description">
                        <span>{{ end.time }}</span>
                        <p>{{ end.nextcompanyName }}</p>
                    </template>
                </el-step>
            </el-steps>
        </el-dialog>
        <el-dialog title="提示" class="myEl" :visible.sync="dialogVisible1" width="30%" :before-close="handleClose">
            <span>是否将选中的论文批量操作,</span>
            <span style="color:red">操作后不可修改!</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit(2, 1)">通 过</el-button>
                <el-button type="danger" @click="submit(3, 1)">不通过</el-button>
            </span>
        </el-dialog>
        <Foot />
    </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import Preview from "@/views/Declare/Preview";
import FullPreview from "../Declare/FullPreview";

export default {
    name: "Expert",
    data() {
        return {
            user: {}, // 审核项目
            tabClick: 0,
            total: 1,
            date: "",
            status: 1,
            lookStatus: "",
            tableData: [],
            tableData1: [],
            Page1: 1,
            yulan: "",
            sbbYear: "", //申报表年份
            value: 1,
            PageSize1: 10,
            isPopup: false,
            contentInfo: [],
            comment: "", //文本框
            reportstatus: [],
            restatus: "1",
            baogao: "",
            cgzbg: "",
            zbgdata: [], //主报告数据
            showall: "",
            fj: "",
            sbb: "",
            cgzbg1: "",
            dow: "",
            jindu: [],
            useRsubmit: {
                time: "",
                zt: "",
                comment: "",
            },
            end: {
                time: "",
                nextcompanyName: "",
                zt: "",
            },
            active: "",
            dialogVisible: false,
            CompanyID: "",
            percentage: "",
            isIndeterminate: true,
            checkedCities: [],
            // cities: cityOptions,
            checkAll: false,
            dialogVisible1: false,
            keyword: "",
            year: new Date().getFullYear().toString(),//element组件默认值为String，传数字会读取不出来
            pickerOptions: {
                // 禁选今日之后的时间,time是当前时间选择器的显示内容
                disabledDate(time) {
                    const date = new Date(); //获取当前时间信息
                    const year = date.getFullYear(); //获取当前年份
                    const timeYear = time.getFullYear(); //获取时间选择器的所有年份
                    // 2020之前与今年之后的全部禁用
                    return timeYear < 2020 ? timeYear < 2020 : timeYear > year;
                },
            },
        };
    },
    created() {
        this.getstatus();
        this.getReview();
    },
    updated() { },
    mounted() {
        // this.getClassify();
    },
    inject: ["reload"],
    methods: {
        openEl() {
            if (this.checkedCities.length > 0) {
                this.dialogVisible1 = true;
            } else {
                this.$message({
                    type: "warning",
                    message: "请选择需要操作的报告！",
                });
            }
        },
        handleCheckAllChange(val) {
            this.checkedCities = val ? this.tableData : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.tableData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
        },
        getJd(id) {
            let that = this;
            // console.log(row)
            for (let key in that.end) {
                that.end[key] = "";
            }
            this.$axios
                .post(
                    "flow/flowtimeline",
                    this.$qs.stringify({
                        ReportID: id,
                        token: sessionStorage.getItem("token"),
                    })
                )
                .then((res) => {
                    console.log(res.data.data);
                    that.jindu = [];
                    if (res.data.code == 10000) {
                        that.jindu = res.data.data;
                        if (this.jindu.length > 0) {
                            this.dialogVisible = true;
                            console.log(this.jindu);
                            that.useRsubmit.time = this.jindu[0].datetime;
                            that.useRsubmit.zt = "已提交";
                            that.jindu.forEach(function (val, index) {
                                // if(val.operation==)
                                switch (val.operation) {
                                    case "1":
                                        val.zt = "待审核";
                                        break;
                                    case "2":
                                        val.zt = "审核通过";
                                        break;
                                    case "3":
                                        val.zt = "审核未通过";
                                        break;
                                    case "4":
                                        val.zt = "待评分";
                                        break;
                                }
                                that.jindu[0].companyName = "";
                                that.jindu[0].zt = "提交成果";
                                if (val.companyName == val.nextcompanyName && val.operation == 1) {
                                    val.zt = "提交成果";
                                    val.companyName = "";
                                }
                                if (index == that.jindu.length - 1 && val.sysmsg == "审核通过！" && val.operator != 1) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.sysmsg == "审核通过！" && val.operator == 1) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待评分";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.companyName == "") {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (
                                    index == that.jindu.length - 1 &&
                                    val.operation == 3 &&
                                    val.companyID != val.nextcompanyID
                                ) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.sysmsg === null && val.operation != 1) {
                                    // that.end.time = that.jindu[index].datetime;
                                    // that.end.zt = "待评分";
                                    // that.end.nextcompanyName ="";
                                    for (let key in that.end) {
                                        that.end[key] = "";
                                    }
                                }

                                if (val.sysmsg == "审核通过！" && val.companyName == "中国煤炭工业协会") {
                                    that.jindu = that.jindu.slice(0, index + 1);
                                    that.jindu[that.jindu.length - 1].zt = "";
                                }
                                if (that.jindu.length == 0) {
                                    that.active = 1;
                                } else {
                                    that.active = that.jindu.length;
                                }
                            });
                            // this.jindu.forEach(val => {
                            // if(val.operation==1){
                            //   val.operation="审核通过"
                            // }eli
                            // switch (val.operation) {
                            //   case "1":
                            //     val.operation = "待审核";
                            //     break;
                            //   case "2":
                            //     val.operation = "审核通过";
                            //     break;
                            //   case "3":
                            //     val.operation = "审核未通过";
                            //     break;
                            // }
                            // });
                        } else {
                            this.$message({
                                type: "warning",
                                message: "暂无进度信息",
                            });
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
        },
        dowCg(i) {
            if (i == 1) {
                window.location.href = this.sbb;
                console.log(this.sbb);
            } else {
                console.log(this.zgzbg);
                window.location.href = this.cgzbg1;
            }
        },
        setYear() {
            this.Page1 = 1;
            this.PageSize1 = 10;
            this.getReview();
        },
        getCg() {
            this.Page1 = 1;
            this.PageSize1 = 10;
            this.keyword = "";
            this.getReview();
        },

        // getClassify: function() {
        //   var that = this;
        //   // 使用promise处理异步。
        //   var arr1=this.getReview()

        //   this.getReview().then(function() {
        //     // console.log("获取分类结束！");
        //     that.updateAllContent(arr1);
        //   });

        // },
        // updateAllContent(arr){
        //     console.log(arr)
        // },
        getReview() {
            var that = this;
            console.log("dd" + this.restatus + "dd3");
            that.$axios
                .post(
                    "report/selectExamineReport?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        lx: this.restatus,
                        page: this.restatus == 2 ? "" : this.Page1,
                        num: this.restatus == 2 ? "" : this.PageSize1,
                        keyword: this.keyword,
                        year: this.year,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res.data, 111);
                        this.tableData = [];
                        this.tableData1 = [];
                        // var dom = document.querySelectorAll(
                        //   "#Statistics .table .el-checkbox__input"
                        // );
                        // if (this.restatus == 1) {
                        //   // this.mLable[0].style.display = "block";
                        //   dom.forEach(val => {
                        //     console.log(val);
                        //     val.style.display = "block";
                        //   });
                        // } else {
                        //   // this.mLable[0].style.display = "none";
                        //   dom.forEach(val => {
                        //     val.style.display = "none";
                        //   });
                        // }
                        if (this.restatus == 1 || this.restatus == 3) {
                            this.tableData = res.data.data;
                            this.total = res.data.total_num;
                        } else {
                            console.log(res.data.data);
                            this.tableData1 = res.data.data;
                            var st = (this.Page1 - 1) * this.PageSize1;
                            this.tableData = this.tableData1.slice(
                                this.Page1 == 1 ? 0 : st,
                                this.PageSize1 * this.Page1
                            );
                            this.total = this.tableData1.length;
                        }
                        // }
                        // else {
                        //   if (this.restatus == 1) {
                        //     for (var key in res.data.data) {
                        //       this.tableData.push(res.data.data[key]);
                        //     }
                        //   } else {
                        //     for (var key1 in res.data.data) {
                        //       this.tableData1.push(res.data.data[key1]);
                        //     }
                        //     this.total = this.tableData1.length;

                        //     var st = (this.Page1 - 1) * this.PageSize1;
                        //     this.tableData = this.tableData1.slice(
                        //       this.Page1 == 1 ? 0 : st,
                        //       this.PageSize1 * this.Page1
                        //     );
                        //   }
                        // }
                        // this.tableData = res.data.data;
                        // console.log(this.tableData, 666666);

                        // console.log(this.tableData);

                        // let arr=[];
                        // this.tableData.forEach(val=>{
                        //     arr.push(val.ID)
                        // })

                        // return arr
                        // this.tableData.forEach(val => {
                        //   that.$axios
                        //     .post(
                        //       "reportcontent/info",
                        //       that.$qs.stringify({
                        //         token: sessionStorage.getItem("token"),
                        //         ReportID: val.ID
                        //       })
                        //     )
                        //     .then(res1 => {
                        //       if (res1.data.code == 10000) {
                        //         console.log(res1, 66666);
                        //         val.ClassName = res1.data.category.ClassName;
                        //         val.ParentClassName = res1.data.category.ParentClassName;
                        //       }
                        //     });
                        // });
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        getReportcontent() {
            var that = this;
            console.log(this.user.ID);
            that.$axios
                .post(
                    "word/sbb?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ID,
                    })
                )
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 10000) {
                        console.log(res.data.data);
                        this.sbb = res.data.data;
                    }
                });
            that.$axios
                .post(
                    "word/words?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ID,
                    })
                )
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 10000) {
                        console.log(res.data.data);
                        this.cgzbg1 = res.data.data;
                    }
                });
            that.$axios
                .post(
                    "reportcontent/info?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ID,
                        MouldID: this.user.MouldID,
                    })
                )
                .then((res) => {
                    console.log(res.data, "所有报告");
                    if (res.data.code == 10000) {
                        this.contentInfo = res.data.data;
                        this.yulan = JSON.stringify(this.contentInfo);
                        this.sbbYear = res.data.year;
                        this.contentInfo.forEach((el) => {
                            if (el.Title == "cgzbg") {
                                //按顺序写入数组
                                this.cgzbg = el.Content;
                            }
                            if (el.Title == "fj1") {
                                //按顺序写入数组
                                this.fj = el.Content;
                            }
                            // if (el.Title == "") {
                            //   console.log("sbb");
                            //   this.sbb = el.Content;
                            // }
                            // if (el.Title == "cgzbg") {
                            //    console.log("zgzbg")
                            //   this.cgzbg1 = el.Content;
                            // }
                        });
                        /* if(el.Title == 'cgzbg_cggy'){//按顺序写入数组
                this.zbgdata[0] = el.Content;
              }
              if(el.Title == 'cgzbg_qyjj'){
                this.zbgdata[1] = el.Content;
              }
              if(el.Title == 'cgzbg_ssbj'){  
                this.zbgdata[2] = el.Content;
              }
              if(el.Title == 'cgzbg_nh'){
                this.zbgdata[3] = el.Content;
              }
              if(el.Title == 'cgzbg_zyzf'){  
                this.zbgdata[4] = el.Content;
              }
              if(el.Title == 'cgzbg_ssxg'){
                this.zbgdata[5] = el.Content;
              }
            })
          /*  this.showall='';
            
            for(var i=0;i<this.zbgdata.length;i++){
              this.showall+=''+this.zbgdata[i];
            }*/
                    } else {
                        console.log(res.data);
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        getBaogao() {
            var that = this;
            that.$axios
                .post(
                    "check/ccresult?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ID,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res, "报告");
                        if (res.data.data[0]) {
                            this.baogao = res.data.data[0];
                            this.percentage = (res.data.data[0].wordRepetitionRate * 100).toFixed(2);
                            console.log(this.percentage);
                        }
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        submit(e, i) {
            var that = this;
            console.log(e, 5555555555555555555);
            // console.log(this.user);

            this.$confirm("确认操作, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    if (i) {
                        var json = [];
                        console.log(this.checkedCities);
                        this.checkedCities.map((val) => {
                            json.push({ ID: val.ID, Status: e, comment: "" });
                        });
                        this.checkedCities = [];
                        that.$axios
                            .post(
                                "report/Batch_updatestatus",
                                that.$qs.stringify({
                                    token: sessionStorage.getItem("token"),
                                    IDS: JSON.stringify(json),
                                })
                            )
                            .then((res) => {
                                if (res.data.code == 10000) {
                                    that.$message({
                                        type: "success",
                                        message: res.data.msg,
                                    }),
                                        that.getReview();
                                    that.dialogVisible1 = false;
                                } else {
                                    that.$message({
                                        type: "warning",
                                        message: res.data.msg,
                                    }),
                                        that.getReview();
                                    that.dialogVisible1 = false;
                                }
                            });
                    } else {
                        that.$axios
                            .post(
                                "report/updatestatus?token=" + sessionStorage.getItem("token"),
                                that.$qs.stringify({
                                    ID: this.user.ID,
                                    Status: e,
                                    comment: this.comment,
                                })
                            )
                            .then((res) => {
                                if (res.data.code == 10000) {
                                    that.tabchange(0);
                                    that.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    that.$axios.post(
                                        "message/updatestatus",
                                        that.$qs.stringify({
                                            type: 1,
                                            ReportID: this.user.ID,
                                            token: sessionStorage.getItem("token"),
                                        })
                                    );
                                    that.reload();
                                } else {
                                    that.$message({
                                        message: res.data.msg,
                                        type: "warning",
                                    });
                                }
                            });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        getstatus() {
            var that = this;
            that.$axios
                .post("parameter/info?token=" + sessionStorage.getItem("token") + "&tablename=report&fieldname=status")
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res.data.data);
                        this.reportstatus = res.data.data;
                        this.reportstatus.splice(0, 1);
                        this.reportstatus.splice(2, 1); //清除0.3
                        // this.total1 = res.data.data.total_num;
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        downloadAll(id) {
            var that = this;
            that.$axios
                .post(
                    "excel/zip?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ID: id,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        window.location.href = res.data.filepath

                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        Popups(a) {
            this.isPopup = a;
            // this.isPopup = !this.isPopup;
        },
        tabchange(a, b, c) {
            if (c != 3) {
                this.tabClick = a;
            }
            if (b) {
                this.user = b;
                this.CompanyID = b.CompanyID;
                // this.$axios.post("/")
                this.getReportcontent(); //获取文件地址;
                this.getBaogao();
                //this.getReview();
            }
            // if (c) {
            this.lookStatus = c;
            // }
            if (c == 2) {
                // window.frames["hrong"].location.href="http://view.xdocin.com/xdoc?_xdoc="+this.cgzbg;
                console.log(this.cgzbg, "主报告");
                // document.getElementById("aaa").src="http://view.xdocin.com/xdoc?_xdoc="+this.fj;
                // document.getElementById("bbb").src="http://view.xdocin.com/xdoc?_xdoc="+this.cgzbg;
            }
            if (c == 3) {
                if (this.fj) {
                    // window.frames["hrong"].location.href="http://view.xdocin.com/xdoc?_xdoc="+this.contentInfo[0].Content;
                    window.location.href = this.fj;
                } else {
                    this.$message({
                        message: "暂无附件信息",
                        type: "warning",
                    });
                }
            }
            // if (c == 4) {
            // this.getBaogao();
            // if (this.fj) {
            // console.log(this.baogaoUrl);
            // .src=this.baogaoUrl
            //   window.location.href = this.fj;
            // } else {
            //   this.$message({
            //     message: "暂无附件信息",
            //     type: "warning"
            //   });
            // }
            // }
        },
        CurrentChange1(val) {
            //console.log(val)
            this.Page1 = val;
            //this.GetClass()
            this.getReview();
        },
        handleSizeChange1(val) {
            //console.log(val)
            this.PageSize1 = val;
            //this.GetClass()
            this.getReview();
        },
    },
    watch: {
        keyword: function () {
            this.Page1 = 1;
            this.getReview();
        },
    },
    components: {
        Head,
        Foot,
        Nav,
        Preview,
        FullPreview,
    },
};
</script>
<style lang="less">
#Statistics {
    .t-left {
        .el-input__inner {
            font-size: 0.16rem;
            width: 2rem;
            height: 0.4rem;
            line-height: 0.4rem;
        }
    }

    .table {
        .el-checkbox__input {
            top: -0.6rem;
        }
    }

    .show {
        .el-checkbox__input {
            display: none;
        }
    }

    .myEl {
        .el-dialog__title {
            font-size: 0.2rem;
            font-weight: normal;
        }
    }
}

.el-dialog {
    .el-dialog__title {
        font-size: 0.4rem;
        font-weight: 500;
    }

    .el-step__head.is-process {
        color: #c0c4cc;
        border-color: #c0c4cc;
    }

    // .el-step.is-vertical .el-step__line {
    //   width: 1px;
    // }
    // .el-step__icon.is-text {
    //   border: 1px solid;
    // }
    .el-step__title.is-finish {
        color: #303133;
    }

    .el-step__title.is-process {
        font-weight: normal;
    }

    .el-step__description.is-finish {
        color: #303133;

        .content {
            display: flex;
            margin-bottom: .2rem;

            .opinion {
                text-indent: 2em;
            }

            .contentMsg {
                position: relative;
                padding-left: 10px;
            }

            .contentMsg ::before {
                content: "";
                background-color: #3796EC;
                width: 3px;
                height: .45rem;
                position: absolute;
                left: 0;
                top: 10%;
                // margin-top: -9px;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                border-radius: 3px;
            }
        }

        p {
            width: 1.6rem;
            height: 0.5rem;
            // margin: 0 auto;
        }

        // div {
        //   width: 1.2rem;
        //   height: 0.4rem;
        //   line-height: 0.4rem;
        //   text-align: center;
        //   color: #fff;
        //   background: #2d65d2;
        //   margin: 0 auto;
        //   margin-top: 0.1rem;
        //   cursor: pointer;
        // }
    }
}
</style>
<style lang="less" scoped>
.time {
    position: relative;

    .time-select {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }
}

.clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}

.btn {
    width: 3rem;
    cursor: pointer;
    height: 0.58rem;
    line-height: 0.58rem;
    font-size: 0.17rem;
    text-align: center;
    background: #2d65d2;
    color: #fff;
}

.btnchange {
    background-color: #f2f2f4;
    color: #000000;
}

.btnmini {
    width: 1rem;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.05rem;
}

.hotspot {
    width: 100%;
    min-width: 1000px;
    font-size: 0.16rem;
    padding: 0.28rem 2.54rem;
    box-sizing: border-box;

    .H-right {
        position: relative;
        width: 11.5rem;
        min-width: 750px;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        min-height: 7.4rem;
        border-left: 1px #eeeeee solid;

        .left-button {
            display: flex;

            .lastBtn {
                margin-left: 0.6rem;
            }
        }

        .btnselect {
            display: flex;
        }

        .title1 {
            font-size: 0.4rem;
            margin: 0.2rem 0 0.5rem;
            text-align: center;
        }

        .H-header {
            .t-left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 0.5rem;

                >span,
                select,
                div,
                input {
                    margin-right: 0.2rem;
                    width: 2rem;
                    height: 0.4rem;
                }

                input {
                    padding: 0.05rem;
                }
            }

            .t-right {
                float: right;
            }
        }

        .t_main {
            .table {
                .list {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    position: relative;
                    border-bottom: 1px #d9d9d9 solid;

                    &:hover {
                        background: #f0f0f0;
                    }

                    .btn {
                        position: absolute;
                        top: 0.2rem;
                        right: 0.2rem;
                    }

                    .l-right {
                        width: 3.14rem;
                        height: 1.56rem;
                        position: relative;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .l-info-box {
                        display: flex;
                        align-items: center;
                        width: 100%;
                    }

                    .l-title {
                        span {
                            font-size: 0.2rem;
                            font-weight: bold;
                            color: #171717;
                            line-height: 0.5rem;
                        }
                    }

                    .l-info {
                        flex: 1;
                        // padding-left: 0.3rem;
                        font-size: 0.16rem;
                        color: #4e4e4e;
                        height: 100%;
                        align-items: flex-start;
                        flex-direction: column;

                        .l-info-name {
                            .hint {
                                margin-top: 0.2rem;
                                font-size: 0.15rem;
                            }

                            span {
                                font-size: 0.2rem;
                                font-weight: bold;
                                color: #171717;
                                line-height: 0.5rem;
                            }

                            i {
                                font-style: normal;
                                background: #ff0a0a;
                                color: #ffffff;
                                display: inline-block;
                                font-size: 0.14rem;
                                margin-left: 0.2rem;
                                height: 0.19rem;
                                text-align: center;
                                border-radius: 0.04rem;
                            }
                        }

                        .l-info-text {
                            height: 0.5rem;
                            margin-bottom: 0.1rem;
                        }

                        .l-info-time {
                            margin-right: 0.2rem;
                            margin-bottom: 0.1rem;
                        }

                        .l-info-text {
                            span {
                                float: left;
                                font-weight: 800;
                                margin-right: 0.2rem;
                                line-height: 0.25rem;
                            }

                            div {
                                margin-left: 0.4rem;
                                line-height: 0.25rem;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 3;
                                overflow: hidden;
                            }
                        }

                        .l-info-loop {
                            span {

                                color: #2d65d2;
                            }
                        }
                    }
                }
            }
        }

        .titleP {
            display: flex;
            align-items: center;
            margin-bottom: 0.18rem;
            font-size: 0.18rem;

            img {
                width: 0.3rem;
                height: 0.3rem;
                margin-right: 0.1rem;
            }
        }

        .info {
            padding: 0.3rem;
            border: 1px #d0d0d0 solid;

            >div {
                height: 0.7rem;
            }

            .span1 {
                margin-left: 0.4rem;
            }

            .span2 {
                margin-left: 0.7rem;
            }

            .span3 {
                margin-left: 0.85rem;
            }

            span {
                display: inline-block;
                color: white;
                width: 1rem;
                text-align: center;
                line-height: 0.5rem;
                height: 0.5rem;
                cursor: pointer;
                background: #2d65d2;
                border-radius: 0.1rem;
            }

            >div:nth-of-type(5) {
                display: flex;

                span {
                    display: inline-block;
                    width: 2.2rem;
                }

                div {
                    margin: 0;
                    margin-top: 0.1rem;
                }
            }

            >div {

                // margin:0.5rem 0 ;
                >div {
                    margin-left: 0.9rem;
                    line-height: 0.26rem;
                }

                >span {
                    // float: left;
                    line-height: 0.5rem;
                }

                .upload {
                    cursor: pointer;
                    width: 10rem;
                    padding-left: 0.5rem;
                    background: url(../../assets/back/18.png) left center no-repeat;
                }
            }
        }

        .title {
            margin: 0.5rem 0;
            font-size: 0.18rem;
            font-family: Microsoft YaHei;

            >input {
                float: right;
                height: 0.35rem;
                margin-right: 50%;
                padding: 0.05rem;
            }

            >div {
                display: flex;
                height: 0.35rem;
                align-items: center;

                >div {
                    height: 0.05rem;
                    width: 0.05rem;
                    border-radius: 50%;
                    background: #2d65d2;
                    margin-right: 0.2rem;
                }
            }
        }

        .jieguo {
            font-size: 0.18rem;
            font-weight: bold;
            margin: 0.5rem 0;
            display: flex;
            align-items: center;

            .jieguospan {
                color: #1c1c1c;
                margin-left: 0.05rem;
            }

            .repetition {
                width: 1.1rem;
                height: 0.4rem;
                background: #ff0000;
                border-radius: 0.05rem;
                color: #fff;
                text-align: center;
                line-height: 0.4rem;
            }

            // line-height: 100%;
            // height: .4rem;
            i {
                display: inline-block;
                width: 0.35rem;
                height: 0.35rem;
                background-image: url("../../assets/back/serach.png");
                background-size: 80%;
                background-repeat: no-repeat;
                background-position: 100% 100%;
                margin-right: 0.05rem;
            }

            span {
                color: #d93838;

                margin-right: 0.2rem;
            }

            a {
                font-weight: 400;
                text-decoration: underline;
                cursor: pointer;
            }
        }

        .yijian {
            >div {
                display: flex;
                height: 0.35rem;
                align-items: center;

                >div {
                    height: 0.05rem;
                    width: 0.05rem;
                    border-radius: 50%;
                    background: #2d65d2;
                    margin-right: 0.2rem;
                }
            }

            textarea {
                position: relative;
                top: -0.35rem;
                left: 1.1rem;
                width: 80%;
            }
        }

        .sub {
            width: 100%;
            display: flex;
            justify-content: center;

            >div {
                border-radius: 0.1rem;
            }
        }
    }
}

.Popup {
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .none {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .a_forms {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 7rem;
        height: 6rem;
        background: white;
        font-size: 0.16rem;

        .f-top {
            height: 0.5rem;
            width: 100%;
            text-align: center;
            line-height: 0.5rem;
            position: relative;
            border-bottom: 1px #cfcfcf solid;

            div {
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 0;
                height: 0.5rem;
                width: 0.5rem;
                background: url("../../assets/back/x.png") center center no-repeat;
            }
        }

        .f-info {
            padding: 0.2rem 0.68rem 0;

            .p-info {
                >.p-input {
                    align-items: center;
                }

                >.upimg {
                    align-items: center;
                    justify-content: space-between;
                }

                >div {
                    margin: 0.2rem 0;
                    display: flex;

                    >.p-time {
                        position: relative;
                        flex: 1;
                        margin: 0 0.2rem;

                        >input {
                            width: 100%;
                            padding: 0.05rem;
                            height: 0.3rem;
                            border: 1px #cccccc solid;
                        }

                        .p-select {
                            width: 100%;
                            top: 0;
                            left: 0;
                            opacity: 0;
                            position: absolute;
                        }

                        .icon {
                            position: absolute;
                            top: 0;
                            right: 0;
                            height: 0.3rem;
                            width: 0.3rem;
                            background: url("../../assets/back/time.png") center center no-repeat;
                        }
                    }

                    >input {
                        flex: 1;
                        padding: 0.05rem;
                        margin: 0 0.2rem;
                        height: 0.3rem;
                        border: 1px #cccccc solid;
                    }

                    >textarea {
                        flex: 1;
                        padding: 0.05rem;
                        margin: 0 0.2rem;
                        border: 1px #cccccc solid;
                    }

                    i {
                        font-style: normal;
                        color: #ff0d0d;
                    }
                }
            }

            .f-bottom {
                display: flex;
                justify-content: space-around;
                align-items: center;
            }
        }
    }
}

.Popup {
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .none {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .a_forms {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 7rem;
        overflow: auto;
        max-height: 6rem;
        background: white;
        font-size: 0.16rem;

        .f-top {
            height: 0.5rem;
            width: 100%;
            text-align: center;
            line-height: 0.5rem;
            position: relative;
            border-bottom: 1px #cfcfcf solid;

            div {
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 0;
                height: 0.5rem;
                width: 0.5rem;
                background: url("../../assets/back/x.png") center center no-repeat;
            }
        }

        .f-info {
            padding: 0.2rem 0.68rem 0;

            .p-info {
                >.p-input {
                    align-items: center;
                }

                >.upimg {
                    align-items: center;
                    justify-content: space-between;
                }

                >div {
                    margin: 0.2rem 0;
                    display: flex;

                    >.p-time {
                        position: relative;
                        flex: 1;
                        margin: 0 0.2rem;

                        >input {
                            width: 100%;
                            padding: 0.05rem;
                            height: 0.3rem;
                            border: 1px #cccccc solid;
                        }

                        .p-select {
                            width: 100%;
                            top: 0;
                            left: 0;
                            opacity: 0;
                            position: absolute;
                        }

                        .icon {
                            position: absolute;
                            top: 0;
                            right: 0;
                            height: 0.3rem;
                            width: 0.3rem;
                            background: url("../../assets/back/time.png") center center no-repeat;
                        }
                    }

                    >input,
                    select {
                        flex: 1;
                        padding: 0.05rem;
                        margin: 0 0.2rem;
                        height: 0.4rem;
                        border: 1px #cccccc solid;
                    }

                    >textarea {
                        flex: 1;
                        padding: 0.05rem;
                        margin: 0 0.2rem;
                        border: 1px #cccccc solid;
                    }

                    i {
                        font-style: normal;
                        color: #ff0d0d;
                    }
                }
            }

            .f-bottom {
                display: flex;
                justify-content: space-around;
                align-items: center;
                padding: 0.5rem 0;
            }
        }
    }
}

/deep/.el-checkbox {

    .el-checkbox__label {
        width: 100%;
    }
}

// 复选框可选中复制
.el-checkbox {
    user-select: auto !important;
}

.empty-content {
    color: #4e4e4eaf;
    margin-top: 2rem;
    text-align: center;
}
</style>
